import React, { Component } from "react";
import { cloneDeep } from "lodash";
import { Col, Form, Input, InputNumber, Modal, Row, Select } from "antd";
import {
  BankOutlined,
  BarcodeOutlined,
  FundViewOutlined,
  UserOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
import { Upload } from 'antd';
import {PlusOutlined, ProjectOutlined} from '@ant-design/icons';
import {Constants} from "../scripts/settings";
class ProductForm extends Component {
  constructor() {
    super();

    this.state = {

      tags: [],
      imageGallery: [],
      imageGalleryData: [],

    };

    this.formRef = React.createRef();
  }

  handleChange = () => {
    this.formRef.current.setFieldsValue({ subCategory: undefined });
  };

  handleSubmit = () => {
    this.formRef.current.validateFields().then((values) => {
      const formData = new FormData();

      formData.append("name", values.name);
      if((values.base_type) && (values.base_type != undefined)){
        formData.append("base_type", values.base_type);
      }
      if((values.base_row) && (values.base_row != undefined)){
        formData.append("base_row", values.base_row);
      }
      if((values.base_identifier) && (values.base_identifier != undefined)){
        formData.append("base_identifier", values.base_identifier);
      }
      if((values.base_shelf) && (values.base_shelf != undefined)){
        formData.append("base_shelf", values.base_shelf);
      }
      this.props.onSubmit(formData);
    });
  };

  handleWillUnmount = () => {
    this.formRef.current.resetFields();
  };

  handleDidMount = async (data = {}) => {
    const cloneData = cloneDeep(data);
    cloneData.category = cloneData.category ? cloneData.category.id : undefined;
    cloneData.subCategory = cloneData.sub_category
      ? cloneData.sub_category.id
      : undefined;

    this.formRef.current.setFieldsValue(cloneData);
  };

  handleChangeImage = (data) => {
    // this.setState({ fileList })

    if((data.file.status == "removed") && (data.file.originFileObj == undefined)){
      const params = { "imgId": data.file.uid}
      API.product.deleteImage(data.file.uid)
          .then((result) => {
            if (result) {
              this.setState({
                loading: false,
              });
            } else {
              this.setState({ loading: false } );
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
    }
    this.setState({imageGallery: data.fileList, imageGalleryData: data.file})
  };

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
  };

  getBase64 = (file) =>{
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  render() {
    const { onCancel, subCats, submitting, visible, rows, types, shelfs, identifiers } = this.props;
    const {imageGallery} = this.state;


    const props = {
      listType: "picture-card",
      multiple: true,
      onRemove: (file) => {
        let newFileList = imageGallery.find((item) => item === file);
        this.setState({
          fileList: [...imageGallery.filter((item) => item !== newFileList)],
        });
      },
      beforeUpload: (_, newFileList) => {
        this.setState({ imageGallery: [...imageGallery, ...newFileList] });
        return false;
      },
      imageGallery,
    };

    const uploadButton = (
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
      <Modal
        title={Resources.edit}
        visible={visible}
        onOk={this.handleSubmit}
        onCancel={onCancel}
        okText={Resources.confirm}
        cancelText={Resources.cancel}
        okButtonProps={{ loading: submitting }}
        cancelButtonProps={{ disabled: submitting }}
        width={748}
      >
        <Form ref={this.formRef} layout="vertical">
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item
                name="name"
                label={`${Resources.firstName} ${Resources.product}`}
                rules={Rules.required}
              >
                <Input type="text" prefix={<UserOutlined />}  />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="code"
                label={Resources.barcode}
              >
                <Input
                    disabled
                  type="text"
                  prefix={<BarcodeOutlined />}
                  dir="ltr"

                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="base_type"
                label={`${Resources.type}`}
              >
                <Select
                  filterOption
                  // onChange={this.handleChange}
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                  {types.map((cat) => (
                    <Select.Option key={cat.id} value={cat.id} name={cat.title}>
                      {cat.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="base_shelf"
                label={`${Resources.shelf}`}
              >
                <Select
                  filterOption
                  // onChange={this.handleChange}
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                  {shelfs.map((cat) => (
                    <Select.Option key={cat.id} value={cat.id} name={cat.title}>
                      {cat.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="base_row"
                label={`${Resources.row}`}
              >
                <Select
                  filterOption
                  // onChange={this.handleChange}
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                  {rows.map((cat) => (
                    <Select.Option key={cat.id} value={cat.id} name={cat.title}>
                      {cat.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="base_identifier"
                label={`${Resources.identifier}`}
              >
                <Select
                  filterOption
                  // onChange={this.handleChange}
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                  {identifiers.map((cat) => (
                    <Select.Option key={cat.id} value={cat.id} name={cat.title}>
                      {cat.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>


          </Row>
        </Form>
      </Modal>
    );
  }
}

export default ProductForm;
